import React from 'react';

export const initXml = {
  blocks: {
    blocks: [
      {
        deletable: false,
        type: 'createc_madero_initial_block',
        x: 10,
        y: 10,
      },
    ],
  },
};

/* eslint-disable */
export const categoryXml = (
  <xml>
    <category id="Control" categorystyle="control_category" name="%{BKY_LANG_CATEGORY_CONTROLS}" iconclass="control" expandedclass="control-extended">
      <label text="%{BKY_LANG_CATEGORY_CONTROLS}" />
      <block type="controls_if_no_else" />
      <block type="controls_repeat_educabot">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block>
    </category>

    <category id="inputs" categorystyle="inputs_category" name="%{BKY_LANG_CATEGORY_COMPARISON}" iconclass="inputsDigi" expandedclass="inputsDigi-extended">
      <label text="%{BKY_LANG_CATEGORY_COMPARISON}" />
      <block type="createc_logic_compare_ldr">
        <value name="A">
          <block type="createc_ciudad_ldr" />
        </value>
      </block>
      <block type="createc_logic_compare_ship">
        <value name="A">
          <block type="createc_ship" />
        </value>
      </block>
      <block type="createc_logic_compare_bridge">
        <value name="A">
          <block type="createc_bridge" />
        </value>
      </block>
    </category>
  
    <category id="outputs" categorystyle="outputs_category" name="%{BKY_LANG_CATEGORY_LIGHTNING}" iconclass="outputs" expandedclass="outputs-extended">
      <label text="%{BKY_LANG_CATEGORY_LIGHTNING}" />
      <block type="madero_createc_restore_electricity" />
      <block type="createc_luminaria_zona1" />
      <block type="createc_luces_dique3">
        <value name="COLOUR">
          <shadow type="colour_createc_number">
            <field name="COLOUR">#00ff00</field>
          </shadow>
        </value>
      </block>
      <block type="createc_luces_dique3_off" />
      <block type="createc_puente_mujer">
        <value name="COLOUR">
          <shadow type="colour_createc_number">
            <field name="COLOUR">#00ff00</field>
          </shadow>
        </value>
      </block>
      <block type="createc_puente_mujer_off" />
      <block type="createc_senda_peatonal">
        <value name="COLOUR">
          <shadow type="colour_createc_number">
            <field name="COLOUR">#00ff00</field>
          </shadow>
        </value>
      </block>
      <block type="createc_senda_peatonal_off" />
    </category>

    <category id="motors" categorystyle="motors_category" name="%{BKY_LANG_CATEGORY_MOTION}" iconclass="motors" expandedclass="motors-extended">
      <label text="%{BKY_LANG_CATEGORY_MOTION}" />
      <block type="createc_open_puente_mujer" />
    </category>
  </xml>
);
/* eslint-enable */
